export default "__VITE_ASSET__BqF1LvzO__"